<!-- Filters span the row: the selects share the width rather than bunching on the right. -->
<div class="row g-2 mb-3 align-items-center">
  <div class="col-12 col-md-6 col-lg-2">
    <ng-select
      placeholder="Dealer"
      [items]="dealersList"
      [clearable]="true"
      [searchable]="false"
      [(ngModel)]="selectedDealer"
      (change)="loadOrders()"
      bindLabel="shop_name"
      bindValue="id" />
  </div>

  <div class="col-12 col-md-6 col-lg-2">
    <ng-select
      placeholder="Order Status"
      [items]="orderStatusOptions"
      [clearable]="true"
      [searchable]="false"
      [(ngModel)]="selectedOrderStatus"
      (change)="loadOrders()"
      bindLabel="label"
      bindValue="value" />
  </div>

  <div class="col-12 col-md-6 col-lg-2">
    <ng-select
      placeholder="Employee"
      [items]="employeesList"
      [clearable]="true"
      [searchable]="true"
      [(ngModel)]="selectedEmployee"
      (change)="loadOrders()"
      bindLabel="full_name"
      bindValue="id" />
  </div>

  <div class="col-12 col-md-6 col-lg-2">
    <ng-select
      placeholder="Company"
      [items]="companiesList"
      [clearable]="true"
      [searchable]="false"
      [(ngModel)]="selectedCompanyId"
      (change)="loadOrders()"
      bindLabel="name"
      bindValue="id" />
  </div>

  <div class="col-6 col-lg-2">
    <div class="input-group">
      <span class="input-group-text">From</span>
      <input
        type="date"
        class="form-control"
        [attr.max]="toDate"
        title="Order date from"
        [(ngModel)]="fromDate"
        (ngModelChange)="onDateRangeChange()" />
    </div>
  </div>

  <div class="col-6 col-lg-2">
    <div class="input-group">
      <span class="input-group-text">To</span>
      <input
        type="date"
        class="form-control"
        [attr.min]="fromDate"
        title="Order date to"
        [(ngModel)]="toDate"
        (ngModelChange)="onDateRangeChange()" />
    </div>
  </div>

  <div class="col-12 col-lg-2 ms-lg-auto">
    <button
      class="btn btn-soft-primary btn-sm d-flex align-items-center justify-content-center gap-2 w-100"
      (click)="exportTotal()"
      [disabled]="isExporting">
      @if (isExporting) {
        <span class="spinner-border spinner-border-sm"></span>
      } @else {
        <i class="bi bi-download"></i>
      }
      Export
    </button>
  </div>
</div>

@if (isRangeReversed) {
  <p class="text-danger small mb-2">
    <i class="bi bi-exclamation-circle me-1"></i>
    From is after To, so the list is still showing the last range that made sense.
  </p>
}

@if (isDataLoading) {
  <app-loading-spinner [message]="'Loading orders...'" />
} @else {
  @if (orders && !(orders || []).length) {
    <app-info-alert>{{ NO_ORDERS_ALERT_MSG }}</app-info-alert>
  } @else {
    <div class="table-responsive">
      <table class="table align-middle table-hover">
        <thead class="text-muted">
          <tr>
            <th class="text-end">Order Number</th>
            <th class="text-end">Order Date</th>
            <th class="text-end">Dealer</th>
            <th class="text-end">Order By</th>
            <th class="text-end">Order Type</th>
            <th class="text-end">Dispatch Requested Date</th>
            <th class="text-end">Total Boxes</th>
            <th class="text-end">Status</th>
          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let order of orders" (click)="viewOrderDetails(order.id)" style="cursor: pointer">
            <td class="text-end">{{ order.order_number }}</td>

            <td class="text-end">{{ order.created_at | date: 'dd MMM yyyy' }}</td>

            <td class="text-end">
              {{ order.dealer.shop_name }}
              <br />
              <small class="text-muted">{{ order.dealer.first_name }} {{ order.dealer.last_name }}</small>
            </td>

            <td class="text-end">{{ order.employee.full_name }}</td>

            <td class="text-end">{{ OrderTypeTexts[order.order_type] || '-' }}</td>

            <td class="text-end">{{ order.dispatch_requested_date | date: 'dd MMM yyyy' }}</td>

            <td class="text-end">{{ order.total_boxes_ordered }}</td>

            <td class="text-end">
              @if (order.is_order_cancelled) {
                <span class="app-badge badge-danger">Cancelled</span>
              } @else if (order.is_fully_delivered) {
                <span class="app-badge badge-success">Delivered</span>
              } @else if (order.is_partially_shipped && !order.is_fully_shipped) {
                <span class="app-badge badge-warning">Partially Shipped</span>
              } @else if (order.is_fully_shipped) {
                <span class="app-badge badge-soft-primary">Fully Shipped</span>
              } @else {
                <span class="app-badge badge-secondary">Pending</span>
              }
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <app-pagination
      [currentPage]="currentPage"
      [totalCount]="totalCount"
      [pageSize]="pageSize"
      [hasNextPage]="hasNextPage"
      [hasPreviousPage]="hasPreviousPage"
      (pageChange)="onPageChange($event)"></app-pagination>
  }
}
